import { Injectable } from '@angular/core';
import { ActiveToast, ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class MessageHelper {
  constructor(private toaster: ToastrService) {}

  error(message: string, title = 'Error!', timeOut = 5000) {
    this.toaster.error(message, title, {
      enableHtml: true,
      timeOut,
    });
  }

  success(message: string, title = 'Success!', timeOut = 5000) {
    this.toaster.success(message, title, {
      enableHtml: true,
      timeOut,
    });
  }

  warning(message: string, title = 'Warning!', timeOut = 5000) {
    this.toaster.warning(message, title, {
      enableHtml: true,
      timeOut,
    });
  }

  /**
   * Warning toast that stays until the user closes it (close button or tap) or the
   * caller closes it via the returned handle, instead of vanishing after a timeout.
   */
  warningSticky(message: string, title = 'Warning!'): ActiveToast<unknown> {
    return this.toaster.warning(message, title, {
      enableHtml: true,
      disableTimeOut: true,
      closeButton: true,
      tapToDismiss: true,
    });
  }

  /** Success toast that stays until the user closes it, for notices that carry a link to act on. */
  successSticky(message: string, title = 'Success!'): ActiveToast<unknown> {
    return this.toaster.success(message, title, {
      enableHtml: true,
      disableTimeOut: true,
      closeButton: true,
      tapToDismiss: false,
    });
  }

  information(message: string, title = 'Information!', timeOut = 5000) {
    this.toaster.info(message, title, {
      enableHtml: true,
      timeOut,
    });
  }
}
